export default "__VITE_ASSET__d82de462__"